import { UseMutationOptions } from '@tanstack/react-query';

import { CreateLandingPageInput } from 'domains/content/types';
import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

/**
 * Creates a landing page.
 * @param mutateOptions react-query useMutation option
 * @returns the react-query useMutation results
 * See https://react-query-v3.tanstack.com/reference/useMutation for options and return value
 */
const useCreateLandingPage = (mutateOptions: UseMutationOptions<unknown, Error, CreateLandingPageInput>) =>
    useMutation<CreateLandingPageInput>(MutationKeys.CREATE_LANDING_PAGE, CuredApiPaths.LANDING_PAGES, mutateOptions);

export default useCreateLandingPage;
